import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@core/services/session/session.service';

export const authGuard: CanActivateFn = (_route, _state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  const activeSession = sessionService.getActiveSession();
  const isLoggedIn = activeSession !== null;

  if (!isLoggedIn) {
    // TODO: Implementar lógica para devolver al usuario a la página que intentó acceder antes de iniciar sesión
    // { queryParams: { returnUrl: state.url } } lo usamos para redirigir al usuario a la página que intentó acceder después de iniciar sesión
    // router.navigate(["/auth/login"], { queryParams: { returnUrl: state.url } });
    router.navigate(['/auth/login']);
    return false;
  }

  // Validar si la sesión ha expirado
  if (activeSession.expires_at) {
    const now = new Date();
    const expirationDate = new Date(activeSession.expires_at);

    if (expirationDate < now) {
      // La sesión ha expirado, redirigir a la página de renovación
      router.navigate(['/auth/renewal-session']);
      return false;
    }
  }

  return true;
};
